// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-primary);
  border-radius: 2px;
  padding: 32px 24px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.3s ease;
}
.error-modal .error-icon {
  height: 48px;
  width: 48px;
  margin-bottom: 8px;
}
.error-modal h2 {
  font-family: AppFontBold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 12px;
  color: #1A1A1A;
}
.error-modal p::ng-deep {
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-transform: capitalize;
  text-wrap: balance;
  color: #41413F;
  margin-bottom: 20px;
}

.btn {
  height: 54px;
  background: var(--ion-color-primary);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  border: 1px solid var(--ion-color-secondary);
  padding: 12px 40px;
  gap: 6px;
  outline: 1px solid var(--ion-color-secondary);
  outline-offset: var(--outline-offset-default);
}
.btn span {
  font-family: AppFont;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-align: center;
  color: var(--ion-color-secondary);
  text-transform: uppercase;
}
.btn ion-spinner {
  color: var(--ion-color-secondary);
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/fail-loading-receipt/fail-loading-receipt.component.scss"],"names":[],"mappings":"AAAA;EACC,sCAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AACD;AACC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AACF;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAAF;AAGC;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EAEA,kBAAA;EACA,cAAA;EACA,mBAAA;AAFF;;AAMA;EACC,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,4CAAA;EACA,kBAAA;EACA,QAAA;EACA,6CAAA;EACG,6CAAA;AAHJ;AAIC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,yBAAA;AAFF;AAKC;EACC,iCAAA;AAHF;;AAOA;EACC;IACC,2BAAA;IACA,UAAA;EAJA;EAMD;IACC,wBAAA;IACA,UAAA;EAJA;AACF","sourcesContent":[".error-modal {\n\tbackground: var(--ion-color-secondary);\n\tborder: 1px solid var(--ion-color-primary);\n\tborder-radius: 2px;\n\tpadding: 32px 24px;\n\twidth: 100%;\n\ttext-align: center;\n\tanimation: slideUp 0.3s ease;\n\n\t.error-icon {\n\t\theight: 48px;\n\t\twidth: 48px;\n\t\tmargin-bottom: 8px;\n\t}\n\n\th2 {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 24px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 12px;\n\t\tcolor: #1A1A1A;\n\t}\n\n\tp::ng-deep {\n\t\tfont-size: 12px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\ttext-transform: capitalize;\n\n\t\ttext-wrap: balance;\n\t\tcolor: #41413F;\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n.btn {\n\theight: 54px;\n\tbackground: var(--ion-color-primary);\n\tborder-radius: 4px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin: 0 auto;\n\tborder: 1px solid var(--ion-color-secondary);\n\tpadding: 12px 40px;\n\tgap: 6px;\n\toutline: 1px solid var(--ion-color-secondary);\n    outline-offset: var(--outline-offset-default);\n\tspan {\n\t\tfont-family: AppFont;\n\t\tfont-size: 20px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0.01em;\n\t\ttext-align: center;\n\t\tcolor: var(--ion-color-secondary);\n\t\ttext-transform: uppercase;\n\t}\n\n\tion-spinner {\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n\n@keyframes slideUp {\n\tfrom {\n\t\ttransform: translateY(20px);\n\t\topacity: 0;\n\t}\n\tto {\n\t\ttransform: translateY(0);\n\t\topacity: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
